/*
 * Adorix NFC customiser.
 *
 * Front text and font ride along as ordinary line-item properties, so any way
 * of submitting the form carries them. The paid back-side option and the file
 * upload cannot go through Ella's JSON serialiser, so those take over Add to
 * cart the same way the wallet engraving does.
 */
(function () {
  function init(root) {
    if (!root || root.dataset.adxnReady === "1") return;
    root.dataset.adxnReady = "1";

    var form = root.closest("form");
    var textInput = root.querySelector("[data-adxn-text]");
    var countEl = root.querySelector("[data-adxn-count]");
    var modes = Array.prototype.slice.call(root.querySelectorAll("[data-adxn-mode]"));
    var uploadWrap = root.querySelector("[data-adxn-upload]");
    var fileInput = root.querySelector("[data-adxn-file]");
    var fileInfo = root.querySelector("[data-adxn-fileinfo]");
    var thumb = root.querySelector("[data-adxn-thumb]");
    var fileName = root.querySelector("[data-adxn-filename]");
    var clearBtn = root.querySelector("[data-adxn-clear]");
    var dropZone = root.querySelector("[data-adxn-drop]");
    var totalEl = root.querySelector("[data-adxn-total]");

    var feeVariant = root.dataset.feeVariant || "";
    var feePrice = root.dataset.feePrice || "";
    var thumbUrl = null;

    function selectedMode() {
      for (var i = 0; i < modes.length; i += 1) {
        if (modes[i].checked) return modes[i];
      }
      return null;
    }

    function isPaid() {
      var m = selectedMode();
      return !!m && m.getAttribute("data-paid") === "paid";
    }

    function syncCount() {
      if (!countEl || !textInput) return;
      var max = textInput.getAttribute("maxlength") || "";
      countEl.textContent = textInput.value.length + (max ? " / " + max : "");
    }

    function syncMode() {
      var paid = isPaid();
      if (uploadWrap) uploadWrap.hidden = !paid;
      // A file left behind on a free option would be charged for nothing.
      if (!paid) clearFile();
      if (totalEl) {
        totalEl.textContent = paid && feePrice ? "Customised image adds " + feePrice : "";
        totalEl.hidden = !paid;
      }
    }

    function releaseThumb() {
      if (thumbUrl) {
        URL.revokeObjectURL(thumbUrl);
        thumbUrl = null;
      }
    }

    function clearFile() {
      if (fileInput) fileInput.value = "";
      releaseThumb();
      if (fileInfo) fileInfo.hidden = true;
      if (dropZone) dropZone.hidden = false;
    }

    function showFile(file) {
      if (!file) return;
      releaseThumb();
      thumbUrl = URL.createObjectURL(file);
      if (thumb) thumb.src = thumbUrl;
      if (fileName) fileName.textContent = file.name;
      if (fileInfo) fileInfo.hidden = false;
      if (dropZone) dropZone.hidden = true;
    }

    if (textInput) {
      textInput.addEventListener("input", function () {
        syncCount();
        paintPreview();
      });
      syncCount();
    }

    modes.forEach(function (m) {
      m.addEventListener("change", function () {
        syncMode();
        paintPreview();
      });
    });
    syncMode();

    var fontSelect = root.querySelector("[data-adxn-font]");
    if (fontSelect) fontSelect.addEventListener("change", paintPreview);

    if (fileInput) {
      fileInput.addEventListener("change", function () {
        showFile(fileInput.files && fileInput.files[0]);
        paintPreview();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        clearFile();
        paintPreview();
      });
    }

    if (dropZone) {
      ["dragenter", "dragover"].forEach(function (evt) {
        dropZone.addEventListener(evt, function (e) {
          e.preventDefault();
          dropZone.classList.add("is-over");
        });
      });
      ["dragleave", "drop"].forEach(function (evt) {
        dropZone.addEventListener(evt, function (e) {
          e.preventDefault();
          dropZone.classList.remove("is-over");
        });
      });
      dropZone.addEventListener("drop", function (e) {
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (!f || !fileInput) return;
        var dt = new DataTransfer();
        dt.items.add(f);
        fileInput.files = dt.files;
        showFile(f);
        paintPreview();
      });
    }

    // ── Live card mockup ──
    var scene = root.querySelector("[data-adxn-scene]");
    var sideTabs = Array.prototype.slice.call(root.querySelectorAll("[data-adxn-side]"));
    var previewText = root.querySelector("[data-adxn-preview-text]");
    var backFaceEl = root.querySelector("[data-adxn-back-face]");
    var hintEl = root.querySelector("[data-adxn-hint]");
    var previewArtImg = root.querySelector("[data-adxn-preview-art-img]");
    var previewArtDemo = root.querySelector("[data-adxn-preview-art-demo]");

    var FONT_STACKS = {
      Montserrat: '"Montserrat", sans-serif',
      Cinzel: '"Cinzel", serif',
      "Dancing Script": '"Dancing Script", cursive',
      "Great Vibes": '"Great Vibes", cursive',
      "Playfair Display": '"Playfair Display", serif',
      "Bebas Neue": '"Bebas Neue", sans-serif',
    };

    function showSide(side) {
      if (scene) scene.setAttribute("data-active-side", side);
      sideTabs.forEach(function (t) {
        var on = t.getAttribute("data-adxn-side") === side;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
    }

    sideTabs.forEach(function (t) {
      t.addEventListener("click", function () {
        showSide(t.getAttribute("data-adxn-side"));
      });
    });

    // A long name has to shrink, not run off the card. Measured rather than
    // guessed from the character count, because a cursive "W" and a narrow "i"
    // are nowhere near the same width.
    function fitName(el) {
      var box = el.parentElement;
      var maxW = box && box.clientWidth ? box.clientWidth - 12 : 220;
      if (maxW <= 0) return;

      var MAX = 24;
      var MIN = 10;
      el.style.whiteSpace = "nowrap";
      el.style.fontSize = MAX + "px";
      if (el.scrollWidth <= maxW) return;

      var lo = MIN;
      var hi = MAX;
      var best = MIN;
      while (lo <= hi) {
        var mid = Math.floor((lo + hi) / 2);
        el.style.fontSize = mid + "px";
        if (el.scrollWidth <= maxW) {
          best = mid;
          lo = mid + 1;
        } else {
          hi = mid - 1;
        }
      }
      el.style.fontSize = best + "px";
    }

    function paintPreview() {
      if (previewText) {
        var typed = textInput && textInput.value.trim();
        previewText.textContent = typed || "Your Name";
        var fontEl = root.querySelector("[data-adxn-font]");
        var picked = fontEl && fontEl.value;
        previewText.style.fontFamily = FONT_STACKS[picked] || (picked ? '"' + picked + '", serif' : "");
        fitName(previewText);
      }

      // The back face uses the NFC page's own display states: tap = the Adorix
      // QR, image = the artwork placeholder, image-filled = the real upload.
      var m = selectedMode();
      var isArt = !!m && m.getAttribute("data-paid") === "paid";
      var hasFile = !!(fileInput && fileInput.files && fileInput.files[0] && thumbUrl);
      var state = isArt ? (hasFile ? "image-filled" : "image") : "tap";
      if (backFaceEl) backFaceEl.setAttribute("data-back-display", state);

      if (previewArtImg) {
        previewArtImg.innerHTML = hasFile ? '<img src="' + thumbUrl + '" alt="">' : "";
      }

      if (hintEl) {
        hintEl.textContent = isArt
          ? (hasFile ? "Your artwork, centred on the back" : "Upload your artwork to see it here")
          : "Adorix Tap QR — one QR centred on the back";
      }
    }

    function properties() {
      var out = {};
      if (textInput && textInput.value.trim()) out["Front text"] = textInput.value.trim();
      var fontEl = root.querySelector("[data-adxn-font]");
      if (fontEl && fontEl.value) out["Front font"] = fontEl.value;
      var m = selectedMode();
      if (m) out["Back side"] = m.value;
      return out;
    }

    // Only worth taking over the button when there is something a plain form
    // post cannot carry: the extra fee line, or the uploaded artwork.
    function needsTakeover() {
      var hasFile = !!(fileInput && fileInput.files && fileInput.files.length);
      return (isPaid() && feeVariant) || hasFile;
    }

    function variantId() {
      if (!form) return null;
      var el = form.querySelector('[name="id"]');
      return el ? el.value : null;
    }

    function submitOrder(button, goToCheckout) {
      var id = variantId();
      if (!id) return;

      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;

      var fd = new FormData();
      fd.append("items[0][id]", id);
      fd.append("items[0][quantity]", qty);
      var props = properties();
      Object.keys(props).forEach(function (k) {
        fd.append("items[0][properties][" + k + "]", props[k]);
      });
      if (fileInput && fileInput.files && fileInput.files[0]) {
        fd.append("items[0][properties][Artwork]", fileInput.files[0]);
      }

      if (isPaid() && feeVariant) {
        fd.append("items[1][id]", feeVariant);
        fd.append("items[1][quantity]", qty);
        fd.append("items[1][properties][For]", "Customised image on " + (document.title || "this order"));
      }

      var label = button ? button.innerHTML : "";
      if (button) {
        button.disabled = true;
        button.innerHTML = "Adding…";
      }

      fetch("/cart/add.js", { method: "POST", body: fd, headers: { Accept: "application/json" } })
        .then(function (r) {
          if (!r.ok) return r.text().then(function (t) { throw new Error(t); });
          return r.json();
        })
        .then(function () {
          if (goToCheckout) {
            window.location.href = "/checkout";
            return;
          }
          window.location.href = "/cart";
        })
        .catch(function (err) {
          if (button) {
            button.disabled = false;
            button.innerHTML = label;
          }
          window.alert("Could not add to cart. Please try again.\n\n" + (err && err.message ? err.message : ""));
        });
    }

    paintPreview();

    if (form) {
      form.addEventListener(
        "submit",
        function (e) {
          if (!needsTakeover()) return;
          e.preventDefault();
          e.stopPropagation();
          var btn = form.querySelector('[type="submit"], [name="add"]');
          submitOrder(btn, false);
        },
        true
      );
    }
  }

  function boot() {
    document.querySelectorAll("[data-adxn]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
